<!-- Content Area -->
<div class="p-4 md:p-8">
    <div class="flex justify-between items-center mb-6 gap-4">
        <h1 class="text-xl lg:text-3xl font-bold text-gray-900">Role List</h1>
        <button (click)="openAddModal()"
            class="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 text-base lg:text-sm font-semibold rounded-lg transition flex items-center gap-2">
            <span>+</span>
            <span>Add Role</span>
        </button>
    </div>

    <!-- Table -->
    <div class="bg-white rounded-lg shadow-sm mb-6 overflow-x-auto">
        <table class="w-full min-w-[600px]">
            <thead>
                <tr class="border-b border-gray-200">
                    <th class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                        No
                    </th>
                    <th class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                        Name
                    </th>
                    <th class="text-center py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                        Action
                    </th>
                </tr>
            </thead>
            <tbody class="divide-y divide-gray-100">
                <tr *ngFor="let role of Role; let i = index" class="hover:bg-gray-50 transition-colors">
                    <td class="py-4 px-6 text-sm text-gray-900">
                        {{ i + 1 }}
                    </td>
                    <td class="py-4 px-6 text-sm text-gray-900">
                        {{ role.name }}
                    </td>
                    <td class="py-4 px-6">
                        <div class="flex items-center justify-center gap-0">
                            <button (click)="openEditModal(role.id)"
                                class="text-gray-600 hover:text-gray-900 transition-colors border border-[#D5D5D5] py-2 px-4 rounded-l-lg hover:bg-gray-50"
                                title="Edit Role">
                                <img src="assets/visidea/icon/pencil-write.png" class="w-[16px] h-[16px]"
                                    alt="Edit" />
                            </button>
                            <button (click)="openPermissionModal(role)"
                                class="text-gray-600 hover:text-gray-900 transition-colors border border-[#D5D5D5] py-2 px-4 hover:bg-gray-50"
                                title="Set Permission">
                                <img src="assets/visidea/icon/permission.png" class="w-[16px] h-[16px]"
                                    alt="Permission" />
                            </button>
                            <button (click)="deleteRole(role.id, role.name)"
                                class="text-red-500 hover:text-red-700 transition-colors border border-[#D5D5D5] py-2 px-4 rounded-r-lg hover:bg-red-50"
                                title="Delete Role">
                                <img src="assets/visidea/icon/bin.png" class="w-[16px] h-[16px]"
                                    alt="Delete" />
                            </button>
                        </div>
                    </td>
                </tr>

                <!-- Empty State -->
                <tr *ngIf="Role.length === 0">
                    <td colspan="3" class="py-8 text-center text-gray-500">
                        Tidak ada data role
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Pagination -->
        <div class="flex items-center justify-between px-6 py-4 border-t border-gray-200">
            <button class="flex items-center gap-2 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg">
                <img src="assets/visidea/icon/left.png" class="w-[12px] h-[12px]" alt="" />
                <span>Previous</span>
            </button>

            <button class="flex items-center gap-2 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg">
                <span>Next</span>
                <img src="assets/visidea/icon/right.png" class="w-[12px] h-[12px]" alt="" />
            </button>
        </div>
    </div>
</div>

<!-- Modal Add/Edit Role -->
<div *ngIf="isModalOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-lg shadow-xl max-w-md w-full p-6 animate-fadeIn" (click)="$event.stopPropagation()">
        <div class="flex justify-between items-center mb-6">
            <h2 class="text-2xl font-bold text-gray-900">
                {{ isEditMode ? "Edit Role" : "Add New Role" }}
            </h2>
            <button (click)="closeModal()" class="text-gray-400 hover:text-gray-600 text-2xl">
                &times;
            </button>
        </div>

        <form (ngSubmit)="onSubmit()" #roleFormElement="ngForm">
            <!-- Name -->
            <div class="mb-6">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Role Name <span class="text-red-500">*</span>
                </label>
                <input type="text" [(ngModel)]="roleForm.name" name="name" required minlength="3" maxlength="50"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter role name (e.g., Administrator)" />
                <p class="mt-1 text-xs text-gray-500">
                    Minimal 3 karakter, maksimal 50 karakter
                </p>
            </div>

            <!-- Buttons -->
            <div class="flex gap-3">
                <button type="button" (click)="closeModal()" [disabled]="isSubmitting"
                    class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition disabled:opacity-50">
                    Cancel
                </button>
                <button type="submit" [disabled]="isSubmitting"
                    class="flex-1 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition disabled:opacity-50 disabled:cursor-not-allowed">
                    <span *ngIf="!isSubmitting">
                        {{ isEditMode ? "Update" : "Create" }}
                    </span>
                    <span *ngIf="isSubmitting"> Processing... </span>
                </button>
            </div>
        </form>
    </div>
</div>

<!-- Modal Set Permission -->
<div *ngIf="isPermissionModalOpen"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
    (click)="closePermissionModal()">
    <div class="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] flex flex-col animate-fadeIn"
        (click)="$event.stopPropagation()">
        <!-- Header -->
        <div class="flex justify-between items-center p-6 border-b border-gray-200">
            <div>
                <h2 class="text-2xl font-bold text-gray-900">Set Permission</h2>
                <p class="text-sm text-gray-600 mt-1">
                    Role:
                    <span class="font-semibold">{{
                        currentRoleForPermission?.name
                        }}</span>
                </p>
            </div>
            <button (click)="closePermissionModal()" class="text-gray-400 hover:text-gray-600 text-2xl">
                &times;
            </button>
        </div>

        <!-- Body - Scrollable -->
        <div class="flex-1 overflow-y-auto p-6">
            <!-- Action Buttons -->
            <div class="flex gap-2 mb-4">
                <button type="button" (click)="selectAllPermissions()"
                    class="px-3 py-1.5 text-sm bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 transition">
                    Select All
                </button>
                <button type="button" (click)="deselectAllPermissions()"
                    class="px-3 py-1.5 text-sm bg-gray-50 text-gray-600 rounded-lg hover:bg-gray-100 transition">
                    Deselect All
                </button>
                <div class="ml-auto text-sm text-gray-600">
                    <span class="font-semibold">{{
                        selectedPermissions.length
                        }}</span>
                    / {{ allPermissions.length }} selected
                </div>
            </div>

            <!-- Permission List -->
            <div class="space-y-2">
                <div *ngFor="let permission of Permission"
                    class="flex items-center p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition cursor-pointer"
                    (click)="togglePermission(permission.name)">
                    <input type="checkbox" [checked]="isPermissionSelected(permission.name)"
                        (click)="$event.stopPropagation()" (change)="togglePermission(permission.name)"
                        class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer" />
                    <label class="ml-3 text-sm font-medium text-gray-900 cursor-pointer flex-1">
                        {{ permission.name }}
                    </label>
                </div>

                <!-- Empty State -->
                <div *ngIf="Permission.length === 0" class="text-center py-8 text-gray-500">
                    Tidak ada data permission
                </div>
            </div>

            <!-- Pagination -->
            <div class="flex items-center justify-between mt-4">
                <button class="px-3 py-1.5 bg-gray-100 rounded-lg text-sm disabled:opacity-50"
                    (click)="prevPermissionPage()" [disabled]="currentPermissionPage === 1">
                    Prev
                </button>

                <span class="text-sm text-gray-600">
                    Page {{ currentPermissionPage }} /
                    {{ totalPermissionPages }}
                </span>

                <button class="px-3 py-1.5 bg-gray-100 rounded-lg text-sm disabled:opacity-50"
                    (click)="nextPermissionPage()" [disabled]="currentPermissionPage === totalPermissionPages">
                    Next
                </button>
            </div>
        </div>

        <!-- Footer -->
        <div class="flex gap-3 p-6 border-t border-gray-200">
            <button type="button" (click)="closePermissionModal()" [disabled]="isSubmitting"
                class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition disabled:opacity-50">
                Cancel
            </button>
            <button type="button" (click)="updateRolePermissions()" [disabled]="isSubmitting"
                class="flex-1 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition disabled:opacity-50 disabled:cursor-not-allowed">
                <span *ngIf="!isSubmitting">Save Permissions</span>
                <span *ngIf="isSubmitting">Processing...</span>
            </button>
        </div>
    </div>
</div>
